import apiService from "../services/apiCore";
import { endpoints } from "../apiEndpoints/apiEndpoints";

// Existing APIs
export const getNcodesAPI = async (id) => {
  try {
    const response = await apiService.get(endpoints.ncodes, { id });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Updated to accept token and id (query parameter)
export const getResultAPI = async (ids, token, id) => {
  try {
    const payload = { ids };
    
    // Add token to payload if it exists
    if (token) {
      payload.token = token;
    }
    
    // Build URL with query parameter if id is provided
    let url = endpoints.getResult;
    if (id) {
      url = `${endpoints.getResult}?id=${id}`;
    }
    
    const response = await apiService.post(url, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Updated to accept token parameter
export const submitQuizAPI = async (payload, token) => {
  try {
    const requestPayload = { ...payload };
    
    // Add token to payload if it exists
    if (token) {
      requestPayload.token = token;
    }
    
    const response = await apiService.post(endpoints.getInnerDriveQuizResult, requestPayload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get personality test options
export const getPersonalityTestOptionsAPI = async () => {
  try {
    const response = await apiService.get(endpoints.getPersonalityTestOptions);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Updated API call for personality test submit - now accepts token
export const submitPersonalityTestAPI = async (payload, token) => {
  try {
    const requestPayload = { ...payload };
    
    // Add token to payload if it exists
    if (token) {
      requestPayload.token = token;
    }
    
    const response = await apiService.post(endpoints.submitPersonalityTest, requestPayload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Updated API call for inner needs test submit - now accepts token
export const submitInnerNeedsTestAPI = async (payload, token) => {
  try {
    const requestPayload = { ...payload };
    
    // Add token to payload if it exists
    if (token) {
      requestPayload.token = token;
    }
    
    const response = await apiService.post(endpoints.submitinnerNeedsTest, requestPayload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Updated API call for trait test submit - now accepts token
export const submitTraitTestAPI = async (payload, token) => {
  try {
    const requestPayload = { ...payload };
    
    // Add token to payload if it exists
    if (token) {
      requestPayload.token = token;
    }
    
    const response = await apiService.post(endpoints.submitTraitTest, requestPayload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ NEW: Check Token Expiry API
export const checkTokenExpiryAPI = async (token) => {
  try {
   
    const url = `${endpoints.checkTokenExpiry}/${token}`;
    
    const response = await apiService.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reorder baselines after user drags to final order
export const reorderNcodesAPI = async (payload, token) => {
  try {
    const requestPayload = { ...payload };
    if (token) {
      requestPayload.token = token;
    }
    const response = await apiService.patch(endpoints.reorderNcodes, requestPayload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ NEW: Submit prospect company assessment
export const submitProspectCompanyAPI = async (payload) => {
  try {
    const response = await apiService.post('/public/prospect-company/submit-assessment', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};